export default function SlingshotSmashIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <rect x="40" y="30" width="18" height="26" rx="2" fill="#d9a35b" stroke="#8a5a24" strokeWidth="2.5" />
      <rect x="37" y="25" width="24" height="6" rx="2" fill="#9aa3ad" stroke="#5d6570" strokeWidth="2" />
      <circle cx="49" cy="17" r="8" fill="#9b5cf0" />
      <path d="M44 11l-2-5 4 3zM54 11l2-5-4 3z" fill="#ffd36b" />
      <circle cx="46" cy="17" r="1.6" fill="#fff" />
      <circle cx="52" cy="17" r="1.6" fill="#fff" />
      <path d="M14 60V40M14 40l-7-12M14 40l7-12" stroke="#7d4a1d" strokeWidth="5" />
      <path d="M7 28l9 4 5-4" stroke="#3d2410" strokeWidth="2.5" />
      <circle cx="12.5" cy="15" r="3" fill="#16917a" />
      <circle cx="23.5" cy="15" r="3" fill="#16917a" />
      <circle cx="18" cy="22" r="9" fill="#2fd0ae" />
      <ellipse cx="18" cy="26" rx="5" ry="3.5" fill="#d8fff4" />
      <circle cx="15" cy="20" r="2.4" fill="#fff" />
      <circle cx="21" cy="20" r="2.4" fill="#fff" />
      <circle cx="15.6" cy="20.4" r="1.1" fill="#1a1a1a" />
      <circle cx="21.6" cy="20.4" r="1.1" fill="#1a1a1a" />
      <path d="M16 24.5a2 2 0 0 0 4 0z" fill="#5a1a2a" />
    </svg>
  );
}
